/// A failed API response, keeping the HTTP status so callers can tell
/// "not found" from other failures
export class ApiError extends Error {
    status: number;

    constructor(message: string, status: number) {
        super(message);
        this.name = "ApiError";
        this.status = status;
    }
}

export function isNotFound(error: unknown): boolean {
    return error instanceof ApiError && error.status === 404;
}
